/**
 * GLOBAL CONFIG OBJECTS AND VARS
 */


/* Used on Blog posts and Magnitude Stories posts */
const authorsAccordionConfig = {
    header: '.author-heading',
    heightStyle: 'content',
    collapsible: true,
    active: false,
    animate: true
};

const s23CarouselConfig = {
    arrows: true,
    autoplay: true,
    centerMode: true,
    centerPadding: '0',
    dots: false,
    easing: 'swing',
    focusOnSelect: true,
    infinite: true,
    mobileFirst: true,
    nextArrow: '.slick-next',
    prevArrow: '.slick-prev',
    waitForAnimate: false,
    responsive: [
        {
            breakpoint: 960,
            settings: {
                centerPadding: '218px',
            },
        },
        {
            breakpoint: 480,
            settings: {
                centerPadding: '170px',
            },
        },
        {
            breakpoint: 0,
            settings: {
                centerPadding: '215px',
            },
        },
    ],
}
const s23CarouselConfigNoAutoplay = {
    arrows: true,
    autoplay: false,
    centerMode: true,
    centerPadding: '0',
    dots: false,
    easing: 'swing',
    focusOnSelect: true,
    infinite: true,
    mobileFirst: true,
    nextArrow: '.slick-next',
    prevArrow: '.slick-prev',
    waitForAnimate: false,
    responsive: [
        {
            breakpoint: 960,
            settings: {
                centerPadding: '218px',
            },
        },
        {
            breakpoint: 480,
            settings: {
                centerPadding: '170px',
            },
        },
        {
            breakpoint: 0,
            settings: {
                centerPadding: '215px',
            },
        },
    ],
}

const s23SpeakerCarouselConfig = {
    arrows: true,
    autoplay: true,
    centerMode: true,
    centerPadding: '0',
    dots: false,
    easing: 'swing',
    focusOnSelect: true,
    infinite: true,
    mobileFirst: true,
    nextArrow: '.slick-next',
    prevArrow: '.slick-prev',
    waitForAnimate: false,
    responsive: [
        {
            breakpoint: 960,
            settings: {
                centerPadding: '253px',
            },
        },
        {
            breakpoint: 0,
            settings: {
                centerPadding: '176px',
            },
        },
    ],
}
const s23SpeakerCarouselConfigNoAutoplay = {
    arrows: true,
    autoplay: false,
    centerMode: true,
    centerPadding: '0',
    dots: false,
    easing: 'swing',
    focusOnSelect: true,
    infinite: true,
    mobileFirst: true,
    nextArrow: '.slick-next',
    prevArrow: '.slick-prev',
    waitForAnimate: false,
    responsive: [
        {
            breakpoint: 960,
            settings: {
                centerPadding: '253px',
            },
        },
        {
            breakpoint: 0,
            settings: {
                centerPadding: '176px',
            },
        },
    ],
}


const carousel0324ConfigNoAutoplay = {
    mobileFirst:true,
    autoplay: false,
    autoplaySpeed: 6000,
    dots: true,
    centerMode: true,
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                variableWidth: true,
                centerPadding: '200px',
            }
        },
        {
            breakpoint: 0,
            settings: {
                arrows: false,
                centerPadding: 0,
            }
        }
    ]
};

const carousel0324Config = {
    mobileFirst:true,
    autoplay: true,
    autoplaySpeed: 8000,
    dots: true,
    centerMode: true,
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                arrows: true,
                variableWidth: true,
                centerPadding: '200px',
            }
        },
        {
            breakpoint: 0,
            settings: {
                arrows: false,
                centerPadding: 0,
            }
        }
    ]
};

const carousel0721Config = {
    mobileFirst:true,
    autoplay: true,
    autoplaySpeed: 8000,
    dots: true,
    centerMode: true,
    centerPadding: '91px',
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                variableWidth: true,
            }
        },{
            breakpoint: 641,
            settings: {
                arrows: true,
                centerMode: true,
                centerPadding: '91px',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 10,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '16px',
                slidesToShow: 1
            }
        }
    ]
};

const carousel0721ConfigNoAutoplay = {
    mobileFirst:true,
    autoplay: false,
    autoplaySpeed: 8000,
    dots: true,
    centerMode: true,
    centerPadding: '91px',
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                variableWidth: true,
            }
        },{
            breakpoint: 641,
            settings: {
                arrows: true,
                centerMode: true,
                centerPadding: '91px',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 10,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '16px',
                slidesToShow: 1
            }
        }
    ]
};


const carousel3SlideConfigNoAutoplay = {
    mobileFirst:true,
    autoplay: false,
    infinite: true,
    dots: false,
    centerMode: false,
    centerPadding: 0,
    slidesToShow: 3,
    slidesToScroll: 3,
    variableWidth: true,
    speed: 500,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 1040,
            settings: {
                arrows: true,
                dots: false,
                centerPadding: 0,
                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: false,
                variableWidth: true
            }
        },{
            breakpoint: 760,
            settings: {
                arrows: true,
                dots: false,
                centerPadding: 0,
                centerMode: false,
                slidesToShow: 2,
                slidesToScroll: 2,
                variableWidth: true
            }
        },
        {
            breakpoint: 640,
            settings: {
                arrows: true,
                dots: false,
                centerPadding: 0,
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true
            }
        },
        {
            breakpoint: 450,
            settings: {
                arrows: true,
                dots: false,
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true
            }
        },
        {
            breakpoint: 10,
            settings: {
                arrows: false,
                dots: true,
                centerMode: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth: true
            }
        }
    ]
};

const carousel0324ConfigG2Responsive = [
    {
        breakpoint: 1080,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
        }
    },
    {
        breakpoint: 767,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
        }
    },
    {
        breakpoint: 480,
        settings: {
            variableWidth: false,
            centerMode: false,
            arrows: true,
            dots: false,
        }
    },
    {
        breakpoint: 0,
        settings: {
            variableWidth: true,
            arrows: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: 0,
        }
    }
];

const carousel0324ConfigG2 = {
    mobileFirst: true,
    autoplay: true,
    infinite: true,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: carousel0324ConfigG2Responsive,
};

const carousel0324ConfigG2NoAutoplay = {
    mobileFirst: true,
    autoplay: false,
    infinite: true,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: carousel0324ConfigG2Responsive,
};


const carouselEmpStoriesConfig = {
    mobileFirst:true,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: true,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 640,
            settings: {
                arrows: true,
                dots: true,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 10,
            settings: {
                arrows: false,
                dots: false,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1
            }
        }
    ]
};

const carouselEmpStoriesConfigNoAutoplay = {
    mobileFirst:true,
    autoplay: false,
    arrows: true,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 640,
            settings: {
                arrows: true,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 10,
            settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1
            }
        }
    ]
};






const carouselConfigCarouselWithImageColumn = {
    mobileFirst:true,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: true,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                arrows: true,
                dots: true,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 10,
            settings: {
                arrows: false,
                dots: true,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1
            }
        }
    ]
};

const carouselConfigCarouselWithImageColumnNoAutoplay = {
    mobileFirst:true,
    autoplay: false,
    arrows: true,
    dots: true,
    centerMode: true,
    centerPadding: '0',
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 1200,
            settings: {
                arrows: true,
                dots: true,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1
            }
        },
        {
            breakpoint: 10,
            settings: {
                arrows: false,
                dots: true,
                centerMode: true,
                centerPadding: '0',
                slidesToShow: 1
            }
        }
    ]


};

const genericCarouselConfig = {
    autoplay: true,
    autoplaySpeed: 8000,
    mobileFirst:true,
    dots: true,
    centerMode: true,
    variableWidth: false,
    slidesToShow: 1,
    easing: 'swing',
    prevArrow: '<button type="button" class="slick-prev"><span>Previous</span></button>',
    nextArrow: '<button type="button" class="slick-next"><span>Next</span></button>',
    responsive: [
        {
            breakpoint: 767,
            settings: {
                arrows: true,
                variableWidth: false,
                centerPadding: 0,
            }
        },
        {
            breakpoint: 0,
            settings: {
                arrows: false,
                centerPadding: 0,
                variableWidth: false,
            }
        }
    ]
};

/**
 * GLOBAL LIBRARIES AND POLYFILLS
 */

const seismicUtilities = (function(){
    const Methods = {
        scrub(input, len){
            if (!input || (typeof input != 'string' && typeof input != 'number')){ return false; }
            input = decodeURIComponent(input);
            if (len && len == 'allowspaces'){ input = input.replace(/[^a-zA-Z0-9\.\,\-\_\# ]+/g,''); }
            else { input = input.replace(/[^a-zA-Z0-9\.\-\_\#]+/g,''); }
            input = input.replace(/[\"\'][\s]*javascript(.*)[\"\']/gi, "\"\"");
            input = input.replace(/script(.*)/gi, '');
            input = input.replace(/eval\((.*)\)/gi, '');
            if (typeof len == 'number'){ input = input.substring(0, len); }
            return input;
        },
        scrubUrl(input){
            if (!input || typeof input != 'string'){ return false; }
            input = decodeURIComponent(input);
            input = input.replace(/[^a-zA-Z0-9\-\_\#\/\?\&\:\.\=]+/g,'');
            input = input.replace(/[\"\'][\s]*javascript(.*)[\"\']/gi, "\"\"");
            input = input.replace(/script(.*)/gi, '');
            input = input.replace(/eval\((.*)\)/gi, '');
            return input;
        },
        scrubAlphaNum(input) {
            if (!input || (typeof input != 'string' && typeof input != 'number')) { 
                return ''; 
            } else if (typeof input == 'number') { 
                return input; 
            } else if (typeof input == 'string') {
                return input.replace(/[^a-zA-Z0-9]/gi,'');
            } else {
                return '';
            }
        },
        validateLocalUrl(testUrl) {
            /* Truthy tests to determine whether testUrl is using current host, either as FQD or as absolute or relative path. Assumes testUrl is already scrubbed. */
            if (!testUrl || typeof testUrl != 'string'){ return false; }
            if ( testUrl.startsWith('/wp-content/') || testUrl.startsWith('wp-content/') || testUrl.startsWith('../') || testUrl.startsWith('./') ) { return true; }
            else if (testUrl.startsWith('http') ) {
                /* this would cause failure if a content database has been cloned to another dev environment...
                should only be checked in LIVE or test.seismic.com */
                if (window.location.hostname.toLowerCase().includes("seismic.com")) {
                    var urlObj = new URL(testUrl);
                    return urlObj.hostname === window.location.hostname;
                }
                else { return true; }
            } else {
                return false;
            }
        },
        validateAlphaNumeric(str) {
            return /^[A-Za-z0-9]*$/.test(str);
        },
        validateSubdomain(str) {
            return /^[A-Za-z0-9\-]*$/.test(str);
        },
        makeId(len) {
            if (!len) { var len = 16; }
            var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz1234567890',
                out = 'x-'; /* IDs must start w/ a letter */
            for (var i=0; i<len; i++) {
                var rnum = Math.floor(Math.random() * chars.length);
                out += chars.substring(rnum,rnum+1);
            }
            return out;
        },
        /**
         * @method 	urlEncode
         * @param 	{String} Required
         * Interface for URL encoding, ensuring %20 is used for spaces (instead of +).
         */
        urlEncode(str) {
            if (typeof str == 'undefined'){ return false; }
            else if (typeof str != 'string') { return str; }
            return encodeURIComponent(str).replace('+','%20').replace(/[!'()*]/g, function(c) {
                return '%' + c.charCodeAt(0).toString(16);
            });
        },
        /**
         * Template processor.
         *
         * @method render
         * @param	{String} Template HTML, with placeholders wrapped in curly braces. Placeholders can repeat.
         * @param	{Object} Name-value pairs corresponding to the placeholders. Do not use curly braces to target the placeholders.
         * 					 Multiple instances of a placeholder need only be targeted once.
         * @returns {String} Finished HTML of the template
         * @example
         * 		var templateThing = '<p>More info at {url}: <a href="{url}">{linkText}</a></p>';
         *		var htmlOutput = this.render(templateThing, {'url': 'http://example.com', 'linkText': 'Click to go there'});
         * 		SomeDomObject.innerHTML(htmlOutput);
         */
        render(template, data){
            if (typeof template != 'string' || typeof data != 'object'){ return ''; }
            return template.replace(/{(\w*)}/g,function(m,key){return data.hasOwnProperty(key)?data[key]:"";});
        },
        /**
         * @param   {*} s Seconds as either interger or number string. (Floats are not properly supported.)
         * @returns {String} Runtime in m:ss format. Does not flip to hh:mm:ss.
         *
         * @see     https://stackoverflow.com/questions/3733227/javascript-seconds-to-minutes-and-seconds#answer-37770048
         */
        formatRuntime(s){
            return(s-(s%=60))/60+(9<s?':':':0')+s
        },
        /**
         * @param {Number}      n Number to format
         * @returns {Number}    Number correctly formatted for the current site locale
         */
        format_number(n){
            return (!isNaN(parseInt(n))) ? new Intl.NumberFormat(document.documentElement.lang).format(n) : ''
        }
    };

    return Methods;
})();


/*! js-cookie v3.0.0 | MIT | https://github.com/js-cookie/js-cookie/ */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var n=e.Cookies,r=e.Cookies=t();r.noConflict=function(){return e.Cookies=n,r}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)e[r]=n[r]}return e}var t={read:function(e){return e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}};return function n(r,o){function i(t,n,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape),n=r.write(n,t);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n+c}}return Object.create({set:i,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var n=document.cookie?document.cookie.split("; "):[],o={},i=0;i<n.length;i++){var c=n[i].split("="),u=c.slice(1).join("=");'"'===u[0]&&(u=u.slice(1,-1));try{var f=t.read(c[0]);if(o[f]=r.read(u,f),e===f)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){i(t,"",e({},n,{expires:-1}))},withAttributes:function(t){return n(this.converter,e({},this.attributes,t))},withConverter:function(t){return n(e({},this.converter,t),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(r)}})}(t,{path:"/"})}));

/**
 * Debounce function for better performance
 * DEBOUNCE == wait until specified event FINISHES before executing the function. E.G. screen resize
 * (To limit the rate of a repeating scan or function, see THROTTLE below.)
 *
 * @src https://davidwalsh.name/javascript-debounce-function
 * @usage   var myEfficientFn = debounce(function() {
 *           // All the taxing stuff you do
 *       }, 250);
 *      window.addEventListener('resize', myEfficientFn);
 */
 if (typeof debounce == 'undefined') {
    window.debounce = function(func, wait, immediate) {
        if (!wait || wait == 'undefined') {
            wait = 250;
        }
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
}

/**
 * Throttle function for better performance
 * THROTTLE == control the rate/frequency of a repeating function or scan. E.G. detecting when a page section is in the viewport
 * (To prevent a function from firing until a specified event has finished completely, see DEBOUNCE above.)
 *
 * @src https://skilled.dev/course/throttle
 * @usage   var returnedFunction = throttle(function() {
 *           // Do all the taxing stuff and API requests
 *      }, 500);
 *      window.addEventListener('scroll', returnedFunction);
 */
 const throttle = (callback, delay) => {
    let throttleTimeout = null;
    let storedEvent = null;
    const throttledEventHandler = (event) => {
        storedEvent = event;
        const shouldHandleEvent = !throttleTimeout;
        if (shouldHandleEvent) {
            callback(storedEvent);
            storedEvent = null;
            throttleTimeout = setTimeout(() => {
                throttleTimeout = null;
                if (storedEvent) {
                    throttledEventHandler(storedEvent);
                }
            }, delay);
        }
    };
    return throttledEventHandler;
};


/**
 * $.smartResize()
 * jQuery debouncing plugin
 *
 * @author Paul Irish
 * @src https://www.paulirish.com/2009/throttled-smartresize-jquery-event-handler/
 * @example:
 *   $(window).smartresize(function(){
 *      // code that takes it easy...
 *   });
 */

(function($,sr){
    /* debouncing function from John Hann
     * http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
     */

    var debounce = function (func, threshold, execAsap) {
        var timeout;
        return function debounced(){
            var obj = this, args = arguments;
            function delayed(){
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            };
            if (timeout) {
                clearTimeout(timeout);
            } else if (execAsap) {
                func.apply(obj, args);
            }
            timeout = setTimeout(delayed, threshold || 100);
        };
    };
    jQuery.fn[sr] = function(fn){  return fn ? this.on('resize', debounce(fn)) : this.trigger(sr); };

})(jQuery,'smartresize');



/**
 * counterAnimator and related
 *
 * Start at zero and count up to 300:
 *  <span class="counter-animate">300</span><span class="counter-symbol">%</span>
 *
 * Start at 50 and count up to 300:
 *  <span class="counter-animate" data-end="300">50</span><span class="counter-symbol">%</span>
 *
 * Currency will "magically" convert to Euros for appropriate locale (based on lang of page).
 *  <span class="counter-symbol">$</span><span class="counter-animate" data-end="2000">1,000</span>
 */
const counterAnimator = new IntersectionObserver((counters, observer) => {
    counters.forEach(counter => {
        if (counter.isIntersecting) {
            let fixWidth = false,
                duration = parseInt(counter.target.dataset.duration) || 3000,
                start = parseInt(counter.target.textContent.replace(/,/g, '')),
                end = parseInt(counter.target.dataset.end);

            /* Failsage checks on our start and end values */
            if ( isNaN(end) && isNaN(start) ) {
                return;
            } else if ( isNaN(end) ) {
                end = start;
                start = 0;
                fixWidth = true;
            } else if ( start === end ) {
                start = 0;
                fixWidth = true;
            }

            let range = end - start,
                increment = end > start ? 1 : -1,
                stepTime = Math.abs(Math.floor(duration / range)),
                current = start;

            let symbolElem = counter.target.previousElementSibling;
            if (symbolElem) {
                if ( symbolElem.classList.contains('counter-symbol') && symbolElem.textContent.trim() == '$' && document.documentElement.lang != 'en-US' ) {
                    const detached = symbolElem.parentElement.removeChild(symbolElem);
                    detached.innerHTML = '&euro;';
                    counter.target.insertAdjacentElement('afterend', detached);
                }
            }

            // Reduce jiggle of surrounding text during animation. We only want to do that when we know the ending width.
            if (fixWidth === true) {
                counter.target.style.display = 'inline-flex';
                counter.target.style.width = counter.target.offsetWidth +'px';
            }

            let timer = setInterval(function() {
                current += increment;
                counter.target.textContent = current;
                if (current === end) {
                    counter.target.textContent = counterNumberFormat(current, counter.target.dataset.type);
                    counter.target.style.width = 'auto';
                    clearInterval(timer);
                    counterAnimator.unobserve(counter.target);
                }
            }, stepTime);
        }
    });
}, {threshold: 0.5});

function counterNumberFormat(num, type) {
    if ( typeof num != 'number') { return num; }
    const lang = document.documentElement.lang || 'en-US';
    const std = new Intl.NumberFormat(lang);
    return std.format(num);
}

document.addEventListener('DOMContentLoaded', function(){
    const counterStuff = document.querySelectorAll('.counter-animate');
    counterStuff.forEach(elem => counterAnimator.observe(elem));
});


/**
 * Distance calculation
 * Works on both X and/or Y axes
 *
 * @example
 *   var myDistanceValue = getDistanceBetweenElements(
 *       document.getElementById('first-thing'),
 *       document.getElementById('second-thing')
 *   );
 */
function getPositionAtCenter(element) {
    const {top, left, width, height} = element.getBoundingClientRect();
    return {
        x: left + width / 2,
        y: top + height / 2
    };
}
function getDistanceBetweenElements(a, b) {
    const aPosition = getPositionAtCenter(a);
    const bPosition = getPositionAtCenter(b);
    return Math.hypot(aPosition.x - bPosition.x, aPosition.y - bPosition.y);
}




/**
 * Accordion helpers: 1 of 2
 * Expand/collapse all functionality. Bound to button object created by makeAccordionExpander()
 *
 * @param   {string}    id      ID of the target accordion to toggle. Scrubbed but not verified in DOM.
 * @param   {string}    view    Current view state. If null, assumes accordion is expanded and should be collapsed.
 */
function jquiAccordionToggle(id, view) {
    if (typeof $ !== 'function') { var $ = jQuery; }
    if (typeof $.fn.accordion == 'undefined') { return false; }
    if (typeof id == 'undefined') { return; }

    id = seismicUtilities.scrub(id);
    var acc = $('#' + id);
    if (!acc.length) { return; }
    var accTabs = acc.find('.ui-accordion-header'),
        accTabsIcons = acc.find('.ui-accordion-header-icon'),
        accPanels = acc.find('.ui-accordion-content'),
        tabsActiveClasses = ['ui-accordion-header-active', 'ui-state-active'],
        iconOpen = 'ui-icon-triangle-1-s',
        iconClosed = 'ui-icon-triangle-1-e',
        tabsAttr = {
            "collapsed": {
                'aria-expanded': 'false',
                'aria-selected': 'false',
                'tabindex': '-1'
            },
            "expanded": {
                'aria-expanded': 'true',
                'aria-selected': 'true',
                'tabindex': '0'
            }
        };
    if (!accPanels.length) { return; }
    if (view == 'collapsed') {
        /* Expand 'em */
        accPanels.slideDown(300).attr('aria-hidden', 'false').addClass('ui-accordion-content-active');
        accTabs.attr(tabsAttr.expanded).removeClass('ui-accordion-header-collapsed').addClass(tabsActiveClasses);
        accTabsIcons.removeClass(iconClosed).addClass(iconOpen);
    } else {
        /* Collapse 'em */
        accPanels.slideUp(300).attr('aria-hidden', 'true').removeClass('ui-accordion-content-active');
        accTabs.attr(tabsAttr.collapsed).removeClass(tabsActiveClasses).addClass('ui-accordion-header-collapsed');
        accTabsIcons.removeClass(iconOpen).addClass(iconClosed);
        accTabs.first().attr('tabindex', '0');
        accTabsIcons.first().addClass(iconOpen);
    }

}

/**
 * Accordion helpers: 2 of 2
 * Creates button that will expand/collapse all panels in the specified accordion.
 *
 * @param   {string}    targetId    ID of the target accordion. Scrubbed but not verified in DOM.
 */
function makeAccordionExpander(targetId) {
    if (typeof targetId == 'undefined') { return ''; }
    targetId = seismicUtilities.scrub(targetId);
    const lang = document.documentElement.getAttribute('lang').split('-')[0],
        text = {
        "expand": {
            "de": "Alles enthüllen",
            "en": "Expand all",
            "fr": "Dévoiler tout"
        },
        "collapse": {
            "de": "Versteck alles",
            "en": "Collapse all",
            "fr": "Cacher tout"
        }
    };

    var newExpander = $('<button class="accordion-toggle" aria-controls="'+ targetId +'" aria-live="polite" data-state="collapsed"><span class="accordion-expanded">'+ text.expand[lang] +'</span><span class="accordion-collapsed" aria-hidden="true">'+ text.collapse[lang] +'</span></button>');
    newExpander.on('click', function(){
        var T = $(this);
        jquiAccordionToggle( T.attr('aria-controls'), T.attr('data-state') );
        var newState = (T.attr('data-state') == 'expanded') ? 'collapsed' : 'expanded';
        T.attr('data-state', newState).find('span').each(function(){
            var t = $(this);
            if (t.attr('class') == 'accordion-'+ newState) {
                t.attr('aria-hidden', 'true');
                if (typeof sega4 == 'object' && typeof sega4.tabLogClick == 'function'){
                    sega4.tabLogClick(t.text());
                }
            } else {
                t.removeAttr('aria-hidden');
            }
        }).focus();
    });

    return newExpander;
}

/**
 * Initialize an elements script when that elements enters the viewport.
 *
 * @param {object} element The element to watch
 * @param {function} callback The function to execute when element enters viewport
 * @param {integer} offset A vertical offset to execute script sooner
 */
function initialize_when_in_view(element, callback, offset = 0) {
    if ( element === undefined || callback === undefined ) {
        return
    }

    let initialized = false;

    const is_in_viewport = () => {
        const rect = element.getBoundingClientRect();
        const element_distance_top = rect.top - offset;
        return ( element_distance_top <= (window.innerHeight || document.documentElement.clientHeight) );
    }

    const init = debounce(() => {
        if ( is_in_viewport() && ! initialized ) {
            initialized = true;
            callback();
            document.removeEventListener('scroll', init);
        }
    }, 100)

    document.addEventListener('scroll', init, { passive: true });
}


/**
 * Set browser cookies with vanilla javascript.
 *
 * @param {string} cname        The name of the cookie to set.
 * @param {string} cvalue       The value of the cookie to set.
 * @param {integer} exdays      The number of days to keep the cookie. Default: 7
 * @param {string} path         The path for the cookie to apply. Default /
 * @param {string} sameSite     The setting for the cookie's sameSite property. Default: Lax
 * @param {boolean} secure      Specifies that the cookie should only be transmitted over a secure protocol. Default: true
 */
function setCookieSeismic(cname, cvalue, exdays = 7, path = '/', sameSite = 'Lax', secure = true) {
    let expires
    const date = new Date();
    if (exdays > 0) {
        date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000)
        expires = `expires=${date.toUTCString()}`
    } else if (exdays === 0) {
        expires = 'expires=0'
    } else {
        date.setTime(date.getTime())
        expires = `expires=${date.toUTCString()}`
    }

    let sameSiteValue = '';
    if (sameSite) {
        sameSite = sameSite.toLowerCase();
    }
    switch (sameSite) {
        case 'none':
            sameSiteValue = 'None';
            secure = true; // required by cookie spec
            break;
        case 'strict':
            sameSiteValue = 'Strict';
            break;
        default:
            sameSiteValue = 'Lax';
    }
    const secureValue = (secure == false) ? '' : ';Secure';
    document.cookie = `${cname}=${cvalue};${expires};path=${path};SameSite=${sameSiteValue}${secureValue}`;
}

/**
 * Get a cookies value with vanilla javascript.
 *
 * @param {string} cname The name of the cookie to get.
 * @returns The cookie value.
 */
function getCookieSeismic(cname) {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');

    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
  return "";
}
